import { t } from "i18next";
import { MouseEventHandler, useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { ClipLoader } from "react-spinners";

import { creatingDocumentationActions } from "../../store/documentation-slice";
import { AddButton } from "../AddButton/AddButton";
import {
  CustomEmailInput,
  EmailProps
} from "../CustomEmailInput/CustomEmailInput";
import deleteIcon from "../Modal/delete-icon.png";

import styles from "./share-defect-box.module.css";

type ShareDefectProps = {
  isOpen: boolean;
  onCancel?: MouseEventHandler<HTMLButtonElement>;
  onConfirm?: MouseEventHandler<HTMLButtonElement>;
  showCommentsCheckbox?: boolean;
  emails: EmailProps[];
  loading: boolean;
};

export const ShareDefectBox = ({
  isOpen,
  onCancel,
  onConfirm,
  showCommentsCheckbox = false,
  emails = [],
  loading = false,
}: ShareDefectProps) => {
  const dispatch = useDispatch();

  const [selectedComments, setSelectedComments] = useState(false);
  const [selectedPhotosAttach, setSelectedPhotosAttach] = useState(true);

  const handleComments = () => {
    if (selectedComments) {
      setSelectedComments(false);
      dispatch(creatingDocumentationActions.setShowCommentsInPDF(false));
    } else {
      setSelectedComments(true);
      dispatch(creatingDocumentationActions.setShowCommentsInPDF(true));
    }
  };

  const handleEmailInputChange = useCallback(
    (email: EmailProps) => {
      dispatch(creatingDocumentationActions.addEmail(email));
    },
    [dispatch]
  );

  const handleAttachPhotos = () => {
    if (selectedPhotosAttach) {
      setSelectedPhotosAttach(false);
      dispatch(creatingDocumentationActions.setShowPhotos(false));
    } else {
      setSelectedPhotosAttach(true);
      dispatch(creatingDocumentationActions.setShowPhotos(true));
    }
  };

  return (
    <>
      {isOpen && (
        <div className={styles["share-defect__overlay"]}>
          <div className={styles["share-defect__content"]}>
            <h2 className={styles["share-defect__title"]}>
              {t("ShareDefect")}
            </h2>

            <h4 className={styles["share-defect__note"]}>{t("EnterEmails")}</h4>

            <CustomEmailInput
              initialValues={emails}
              placeholder={t("EnterEmail") ?? ""}
              onInputChange={handleEmailInputChange}
              shareDefect
            />

            {showCommentsCheckbox && (
              <div className={styles["share-defect__checkbox"]}>
                <AddButton
                  background="dark"
                  iconColor="light"
                  icon="check"
                  onClick={handleComments}
                  selected={selectedComments}
                ></AddButton>
                <span
                  className={`${
                    selectedComments &&
                    styles["share-defect__checkbox--checked"]
                  }`}
                >
                  {t("ShowComments")}
                </span>
              </div>
            )}

            <div className={styles["share-defect__checkbox"]}>
              <AddButton
                background="dark"
                iconColor="light"
                icon="check"
                onClick={handleAttachPhotos}
                selected={selectedPhotosAttach}
              ></AddButton>
              <span
                className={`${
                  selectedPhotosAttach &&
                  styles["share-defect__checkbox--checked"]
                }`}
              >
                {t("AttachPhotos")}
              </span>
            </div>

            <div className={styles["share-defect--buttons"]}>
              {onCancel && (
                <button
                  className={styles["share-defect--close"]}
                  onClick={onCancel}
                >
                  <img src={deleteIcon} alt="Delete icon" />
                </button>
              )}

              {onConfirm && (
                <button
                  className={`${styles["share-defect--confirm"]} ${
                    emails.length > 0
                      ? styles["share-defect--confirm-active"]
                      : ""
                  }`}
                  onClick={onConfirm}
                  disabled={emails.length === 0}
                >
                  {loading ? (
                    <ClipLoader color="#ffffff" />
                  ) : (
                    <span>{t("Confirm")}</span>
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
